<template>
  <v-dialog v-model="dialog" max-width="600" content-class="rounded-lg">
    <v-card class="">
      <v-card-title class="d-flex gap-2 justify-space-between align-center">
        <h5 class="mb-0">Solicitação</h5>
        <span class="text-overline">#{{ concession?.id | shortId }}</span>
        <v-spacer />
        <v-chip :color="status[concession?.status]?.color" label small>
          {{ status[concession?.status]?.label || "Pendente" }}
        </v-chip>
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item>
            <v-list-item-avatar class="mr-2">
              <v-icon>mdi-account</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle>Nome do solicitante</v-list-item-subtitle>
              <v-list-item-title>{{ user?.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar class="mr-2">
              <v-icon>mdi-email</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle>E-mail do solicitante</v-list-item-subtitle>
              <v-list-item-title>{{ user?.email }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar class="mr-2">
              <v-icon>mdi-certificate</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle>Tipo de benefício</v-list-item-subtitle>
              <v-list-item-title>
                {{ concessionTypes[concession?.type]?.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar class="mr-2">
              <v-icon>mdi-file</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle>Documentos enviados</v-list-item-subtitle>
              <v-list-item-title v-if="concession?.documentFront">
                Frente do documento
                <v-btn
                  :href="concession?.documentFront"
                  target="_blank"
                  color="primary"
                  text
                  x-small
                >
                  Ver
                  <v-icon size="12" class="ml-1">mdi-open-in-new</v-icon>
                </v-btn>
              </v-list-item-title>
              <v-list-item-title v-if="concession?.documentBack">
                Verso do documento
                <v-btn
                  :href="concession?.documentBack"
                  target="_blank"
                  color="primary"
                  text
                  x-small
                >
                  Ver
                  <v-icon size="12" class="ml-1">mdi-open-in-new</v-icon>
                </v-btn>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar class="mr-2">
              <v-icon>mdi-check-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle>
                Autoriza análise automatizada
              </v-list-item-subtitle>
              <v-list-item-title>
                {{ concession?.allowAi ? "Sim" : "Não" }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-avatar class="mr-2">
              <v-icon>mdi-calendar</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-subtitle> Solicitado em </v-list-item-subtitle>
              <v-list-item-title>
                {{ concession?.createdAt | date }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn text @click="dialog = false"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import concessionTypes from "@/definitions/concessionTypes.json";
export default {
  name: "ConcessionViewModal",
  props: {
    concession: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
  },
  data() {
    return {
      dialog: false,
      concessionTypes,
      status: {
        MANUAL_REVIEW: {
          label: "Em Análise Manual",
          color: "warning",
        },
        PENDING: {
          label: "Em Análise",
          color: "warning",
        },
        REJECTED: {
          label: "Rejeitada",
          color: "warning",
        },
        REVOKED: {
          label: "Cancelada",
          color: "error",
        },
        APPROVED: {
          label: "Aprovada",
          color: "success",
        },
      },
    };
  },
  mounted() {
    this.$parent.$on("showModal", () => {
      this.dialog = true;
    });
  },
  methods: {
    close() {
      this.dialog = false;
    },
  },
};
</script>
